import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrderPaneState {
  showConfigSuccessPopup: boolean;
}

const initialState: OrderPaneState = {
  showConfigSuccessPopup: false,
};

const orderPaneSlice = createSlice({
  name: 'orderPane',
  initialState,
  reducers: {
    setshowConfigSuccessPopup: (state, action: PayloadAction<boolean>) => {
      state.showConfigSuccessPopup = action.payload;
    },
  },
});

export const { setshowConfigSuccessPopup } = orderPaneSlice.actions;

export default orderPaneSlice.reducer;
